import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MopedIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"moped"} ref={ref}/>
});

MopedIcon.displayName = "MopedIcon";
